/**
 * Utility for interacting with Google Maps Distance Matrix API
 * Handles driving distance and duration calculations between locations
 */

import axios from 'axios';

/**
 * Calculate driving distance and duration between two locations using backend API endpoint
 * @param {string} origin - Starting location (city name or address)
 * @param {string} destination - Ending location (city name or address)
 * @returns {Promise<Object>} - Promise resolving to an object with distance (in km) and duration (in hours)
 */
export const getDrivingDistanceAndDuration = async (origin, destination) => {
  try {
    // Use backend API endpoint instead of direct Google API call
    // Import API URL from config for consistency
    const { API_URL } = require('../config/apiConfig');
    
    const response = await axios.get(`${API_URL}/distance`, {
      params: {
        origin,
        destination
      }
    });
    
    if (response.data.success) {
      return response.data.data;
    } else {
      console.error('Backend API error:', response.data.message);
      return { distance: 500, duration: 8 }; // Fallback values
    }
  } catch (error) {
    console.error('Error fetching distance from backend API:', error);
    return { distance: 500, duration: 8 }; // Fallback values in case of API failure
  }
};
